export enum SpotlightStatus {
  active = 'ACTIVE',
  inactive = 'INACTIVE',
}
